import axios from 'axios';

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER_URL || 'api/v1.0/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});
